import { css } from 'emotion';
import { membersDrawerWidth } from 'components/LiveClass/utils/consts';

export const drawer = isMobile => css`
  padding: 0px !important;
  display: flex;
  flex-direction: column;
  ${isMobile
    ? `
    width: 100vw !important;
    z-index: 1000 !important;
  `
    : `
    width: ${membersDrawerWidth}px !important;
    z-index: 40 !important;
  `}
`;

export const header = theme => css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  color: ${theme.color.text};
  border-bottom: solid 1px ${theme.color.grey3};
`;

export const membersButton = theme => css`
  color: ${theme.color.text};

  svg {
    margin-right: 4px;
    height: 14px;
  }
`;

export const membersContainer = css`
  overflow-y: auto;
  padding: 0px 30px;
  position: relative;
  flex-grow: 1;
`;

export const teacherSection = css`
  padding-top: 17px;
`;

export const learnersSection = css`
  padding-top: 26px;
`;

export const sectionLabel = css`
  margin-bottom: 12px;
`;

export const userMedia = isMobile => css`
  margin-bottom: 10px;
  & video {
    width: 100%;
  }
  ${isMobile
    ? `
      position: relative;
      bottom: unset;
      right: unset;
      & video {
        max-height: 270px;
      }
  `
    : `
      & video {
        max-height: 180px;
      }
    `}
`;

export const inviteLearnersContainer = css`
  height: 60px;
  width: 100%;
  box-shadow: 7px 3px 12px 2px rgba(0, 0, 0, 0.1);
  z-index: 2;
  background-color: white;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  > div {
    font-size: 16px;
  }
`;

export const copyButton = css`
  flex-shrink: 0;
  height: 32px !important;
  font-size: 14px !important;

  svg {
    height: 18px;
    width: 18px;
    margin-right: 4px;
  }
`;
